module.exports = __webpack_public_path__ + "img/trash.9afd9670.svg";